// styles
import 'react-quill/dist/quill.snow.css';

// libs
import ReactQuill from 'react-quill';
import { useState, useEffect } from 'react';

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from 'context';

// styled wrapper
import MDEditorRoot from 'components/MDEditor/MDEditorRoot';

function MDEditor({ value = '', onChange, ...rest }) {
    const [content, setContent] = useState(value);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    useEffect(() => {
        setContent(value);
    }, [value]);

    const handleChange = (newContent) => {
        setContent(newContent);
        if (onChange) {
            onChange(newContent);
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image'],
            ['clean'],
        ],
        ...rest.modules,
    };

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'link',
        'image',
    ];

    return (
        <MDEditorRoot ownerState={{ darkMode }}>
            <ReactQuill
                value={content}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                theme="snow"
                {...rest}
            />
        </MDEditorRoot>
    );
}

export default MDEditor;
